module.exports = __webpack_public_path__ + "media/public/tab-question-e5d0e07a.png";